import React from 'react';
import PublicHeader from '../Layouts/PublicHeader/PublicHeader';

const Terms = () => {
  return (
    <div className="legal-page">
      <PublicHeader />
      <main className="legal-page-content" style={{ paddingTop: '96px' }}>
        <section className="legal-hero">
          <p className="legal-eyebrow">AI Tenant Screening Platform</p>
          <h1 className="legal-title">Full Legal &amp; Operations Bundle</h1>
          <p className="legal-intro">
            These terms explain how landlords and tenants can use our AI-powered tenant
            screening platform. Please read them carefully before using the service.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">Landlord Terms &amp; Conditions</h2>
          <p className="legal-text">
            These terms govern landlord use of the AI-powered tenant pre-screening platform. The
            service provides informational summaries only and does not approve or deny tenants.
            Landlords are solely responsible for rental decisions, Fair Housing compliance, and
            listing accuracy. Subscriptions are billed monthly and are non-refundable.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">Tenant Terms &amp; Conditions</h2>
          <p className="legal-text">
            Tenants may voluntarily participate in AI-powered voice screening calls. Participation
            does not guarantee approval or rental. Screening fees are non-refundable once a call is
            initiated. Tenants certify that all information provided is truthful and accurate.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">Privacy Policy &amp; AI Voice Consent</h2>
          <p className="legal-text">
            The platform collects contact information, voice recordings, and call transcripts for
            screening purposes. By using the service, users consent to automated AI-generated voice
            calls, audio recording, transcription, and automated analysis. Data is shared only with
            landlords and essential service providers and is not sold.
          </p>
        </section>
      </main>
    </div>
  );
};

export default Terms;

